import { Chip as MuiChip, ChipProps as MuiChipProps, styled } from "@mui/material";
import CloseIcon from "@/Components/Icons/CloseIcon";

const StyledChip = styled(MuiChip)(({ theme }) => {
  return {
    borderRadius: "2px",
    fontSize: "12px",
    fontWeight: 500,
    backgroundColor: theme.palette.chip.background,
    color: theme.palette.chip.textColor,
    "& .MuiChip-deleteIcon": {
      width: "16px",
      height: "16px",
    },
    "& .MuiChip-label": {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      maxWidth: "200px",
    },
  };
});

interface ChipProps extends MuiChipProps {
  label: React.ReactNode;
}

export const Chip: React.FC<ChipProps> = ({ label, ...props }) => {
  return <StyledChip label={label} {...props} deleteIcon={<CloseIcon />} />;
};

export default Chip;
